/**
 * SGI Constants.
 */
// SGI URL from environment variable (injected by webpack from .env)
export const SGI_URI_BR_URL = process.env.SGI_URI_BR_URL;
// Whether SGI debug logging is enabled (injected by webpack from .env)
export const SGI_DEBUG = process.env.DEBUG_SGI === 'true' || process.env.NODE_ENV === 'development';
// Conference command name for SGI state broadcast
export const SGI_COMMAND = 'sgi';
// Fake participant for SGI display (similar to whiteboard)
export const SGI_PARTICIPANT_ID = 'sgi-share';
export const SGI_PARTICIPANT_NAME = 'SGI Camera View';
// Event types for postMessage communication
export const SGI_EVENTS = {
    SESSION_INIT: 'sgi:session:init',
    STATE_UPDATE: 'sgi:state:update',
    SESSION_END: 'sgi:session:end',
    READY: 'sgi:ready',
    STATE_REQUEST: 'sgi:state:request'
};
// Allowed origins for postMessage
export const SGI_ALLOWED_ORIGINS = [
    'https://meet-br.confereweb.org.br',
    'https://meet.confereweb.org.br',
    'https://uri-br.confereweb.org.br',
    'https://stg.confereweb.org.br',
    'https://confereweb.org.br',
    'http://localhost:3000',
    'http://localhost:8080'
];
